import { Box, Typography } from "@mui/material";
import { memo } from "react";

type SummaryState = {
    icon: string;
    color: string;
    bg: string;
    border: string;
    message: string;
};

type Props = {
    used: number;
    recommended: number;
    dogName?: string;
};

function PackSummaryCard({ used, recommended, dogName }: Props) {
    const diff = used - recommended;

    const STATES = {
        missing: {
            icon: "🔴",
            color: "#B20000",
            bg: "#FFF0F0",
            border: "#FFB3B3",
            message: `Please add ${Math.abs(diff)} more pot${Math.abs(diff) > 1 ? "s" : ""
                } to match ${dogName ? `${dogName}'s` : "your dog's"} plan`,
        },
        perfect: {
            icon: "🟢",
            color: "#7B3306",
            bg: "#F7FFF5",
            border: "#D4F5C8",
            message: `Perfect! This is the recommended amount for ${dogName || "Your dog"
                }`,
        },
        extra: {
            icon: "🟡",
            color: "#8A6E00",
            bg: "#FFF9E5",
            border: "#FFE8A3",
            message: `You're treating ${dogName || "your dog"} to ${diff} extra pot${diff > 1 ? "s" : ""
                } than the recommended ${recommended}.`,
        },
    } as const;

    const summaryState: SummaryState =
        recommended === 0
            ? {
                icon: "ℹ️",
                color: "#4A3428",
                bg: "#FFF9E5",
                border: "#FFE8A3",
                message:
                    "We couldn't calculate a recommendation yet. Please go back and check your dog's daily grams and plan.",
            }
            : diff < 0
                ? STATES.missing
                : diff === 0
                    ? STATES.perfect
                    : STATES.extra;

    return (
        <Box
            sx={{
                background: summaryState.bg,
                border: `2px solid ${summaryState.border}`,
                borderRadius: "12px",
                p: { xs: 1.5, md: 2 },
                mb: 3,
                maxWidth: "100%",
                textAlign: "center",
            }}
        >
            <Typography
                sx={{
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    color: summaryState.color,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <span>{summaryState.icon}</span> {summaryState.message}
            </Typography>
        </Box>
    );
}

export default memo(PackSummaryCard);
